import React from 'react';
import HexagonOutlined from '@mui/icons-material/HexagonOutlined';
const AppLogo = ({ className, color = 'white', fontSize = "medium" }) => (React.createElement(HexagonOutlined, { className: className, fontSize: fontSize, sx: { color } }));
export default AppLogo;
//# sourceMappingURL=AppLogo.js.map